export const getDirections = (total) => {
  return {
    first: 0,
    back: -1,
    next: 1,
    last: Math.ceil(total / 30),
  };
};
export const appName = "";
